function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.30002 0.411996L1.07402 7.721L0.074023 12.321C0.0244063 12.548 0.0326516 12.7838 0.0980009 13.0068C0.16335 13.2298 0.283706 13.4327 0.448003 13.597C0.6123 13.7613 0.815265 13.8817 1.03824 13.947C1.26121 14.0124 1.49703 14.0206 1.72402 13.971L6.32402 12.971L13.56 5.65C13.8178 5.38945 13.962 5.03747 13.961 4.67096C13.9601 4.30446 13.8141 3.95322 13.555 3.694L10.268 0.405996C10.1386 0.276739 9.98501 0.174323 9.81592 0.104635C9.64684 0.0349456 9.46566 -0.00064266 9.28278 -8.51014e-05C9.0999 0.000472457 8.91893 0.0371649 8.75028 0.107883C8.58162 0.178602 8.42861 0.281953 8.30002 0.411996ZM2.81002 12.465L1.57602 11.232L2.20602 8.339L5.70602 11.839L2.81002 12.465Z",
  fill: "black",
  fillOpacity: 0.5
});
var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none"
  }, props), _ref);
};
export default __webpack_public_path__ + "static/media/edit-3.45ffda21.svg";
export { SvgComponent as ReactComponent };